
function hasCorruptedCharacters(str) {

    const corruptedPattern = /[^a-zA-Z0-9_.]/;
    return corruptedPattern.test(str);
}



function CardBmpMap(key) {
  const originalValue = cardMap[key];

  if (!originalValue) {
    return undefined;
  }
  
  if (hasCorruptedCharacters(originalValue)) {
    return originalValue;
  } else {
    return originalValue.toLowerCase();
  }
}


export {CardBmpMap};

const cardMap = {
  4001: "Æ÷¸µÄ«µå",
  4002: "ÆÄºê¸£Ä«µå",
  4003: "ÇªÆÄÄ«µå",
  4004: "µå·ÓÇÁ½ºÄ«µå",
  4005: "»êÅ¸Æ÷¸µÄ«µå",
  4006: "·ç³ªÆ½Ä«µå",
  4007: "ÆäÄÚÆäÄÚ¾ËÄ«µå",
  4008: "ÇÈÅ°Ä«µå",
  4009: "ÃÌÃÌÄ«µå",
  4010: "Àª·Î¿ìÄ«µå",
  4011: "¾ËÇÈÅ°Ä«µå",
  4012: "µµµÏ¹ú·¹¾ËÄ«µå",
  4013: "¾Óµå·¹¾ËÄ«µå",
  4014: "·Î´ÙÇÁ·Î±×Ä«µå",
  4015: "ÄÜµµ¸£Ä«µå",
  4016: "µµµÏ¹ú·¹Ä«µå",
  4017: "»õºñÁöº£º£Ä«µå",
  4018: "¾Óµå·¹À¯ÃæÄ«µå",
  4019: "È£³ÝÄ«µå",
  4020: "ÆÛ¹Ð¸®¾îÄ«µå",
  4021: "·ÎÄ¿Ä«µå",
  4022: "½ºÆ÷¾ÆÄ«µå",
  4023: "µ¥¿ïÇÁ»õ³¢Ä«µå",
  4024: "ÇÃ¶ûÅ©ÅæÄ«µå",
  4025: "½ºÄÌ·¹ÅæÄ«µå",
  4026: "¾ÏµµµÏ¹ú·¹Ä«µå",
  4027: "ÄíÅ©·¹Ä«µå",
  4028: "Å¸·Î¿ìÄ«µå",
  4029: "¿ïÇÁÄ«µå",
  4030: "¸¸µå¶ó°í¶óÄ«µå",
  4031: "ÆäÄÚÆäÄÚÄ«µå",
  4032: "¾Ú¹ö³ªÀÌÆ®Ä«µå",
  4033: "Æ÷Æ÷¸µÄ«µå",
  4034: "¿úÅ×ÀÏÄ«µå",
  4035: "È÷µå¶óÄ«µå",
  4036: "¹«Ä«Ä«µå",
  4037: "½º³×ÀÌÅ©Ä«µå",
  4038: "Á»ºñÄ«µå",
  4039: "½ºÅ¸ÀÌ³ÊÄ«µå",
  4040: "Å©¸®¹ÌÄ«µå",
  4041: "ÄÚÄÚÄ«µå",
  4042: "½ºÆ¿ÃÌÃÌÄ«µå",
  4043: "¾Óµå·¹Ä«µå",
  4044: "½º¸ðÅ°Ä«µå",
  4045: "È£¸¥Ä«µå",
  4046: "¸¶¸£Æ¾Ä«µå",
  4047: "°í½ºÆ®¸µÄ«µå",
  4048: "Æ÷½ºÆ÷¾ÆÄ«µå",
  4049: "¹Ùµ·Ä«µå",
  4050: "¼öµµµÏ¹ú·¹Ä«µå",
  4051: "¿ä¿äÄ«µå",
  4052: "¿¤´õÀª·Î¿ìÄ«µå",
  4053: "ºñÅ¸Å¸Ä«µå",
  4054: "¿£Á©¸µÄ«µå",
  4055: "¸¶¸®³ªÄ«µå",
  4056: "´õ½ºÆ¼³×½ºÄ«µå",
  4057: "¸ÞÆ²·¯Ä«µå",
  4058: "Å¸¶óÇÁ·Î±×Ä«µå",
  4059: "º´Á¤¾Óµå·¹Ä«µå",
  4060: "°íºí¸°Ä«µå",
  4061: "Ä¿³ÊÅõ½ºÄ«µå",
  4062: "¾Æ³ªÄÜ´ÙÅ©Ä«µå",
  4063: "Ä«¶ó¸áÄ«µå",
  4064: "Á¦·ÒÄ«µå",
  4065: "Ä«È£Ä«µå",
  4066: "¿ÀÅ©¿ö¸®¾îÄ«µå",
  4067: "¸Þ°¥·Îµ·Ä«µå",
  4068: "½ºÄÝÇÇ¿ÂÄ«µå",
  4069: "µå·¹ÀÎ¸®¾îÄ«µå",
  4070: "¿¡±â¶óÄ«µå",
  4071: "¿ÀÅ©Á»ºñÄ«µå",
  4072: "°í·½Ä«µå",
  4073: "ÇØÀû½ºÄÌÄ«µå",
  4074: "ºòÇ²Ä«µå",
  4075: "¾Æ¸£°í½ºÄ«µå",
  4076: "¹é·Ã¿ÁÄ«µå",
  4077: "ÈÓÄ«µå",
  4078: "»õºñÁöÄ«µå",
  4079: "¸ÇÆ¼½ºÄ«µå",
  4080: "ÇÃ·Î¶óÄ«µå",
  4081: "È£µåÄ«µå",
  4082: "µ¥ÀúÆ®¿ïÇÁÄ«µå",
  4083: "¶óÇÃ·¹½Ã¾ÆÄ«µå",
  4084: "¸¶¸°½ºÇÇ¾îÄ«µå",
  4085: "¿ÀÅ©½ºÄÌÄ«µå",
  4086: "¼ÖÁ®½ºÄÌÅæÄ«µå",
  4087: "°¡ÀÌ¾Æ½ºÄ«µå",
  4088: "ÇÁ¸±µµ¶óÄ«µå",
  4089: "¼ÒµåÇÇ½¬Ä«µå",
  4090: "¹«³«Ä«µå",
  4091: "ÄÚº¼Æ®Ä«µå",
  4092: "½ºÄÌ¿öÄ¿Ä«µå",
  4093: "¿Àº»´ÀÄ«µå",
  4094: "¾ÆÃÄ½ºÄÌÅæÄ«µå",
  4095: "¸¶¸£½ºÄ«µå",
  4096: "Á¦³ëÅ©Ä«µå",
  4097: "¸¶Å¸Ä«µå",
  4098: "µµ±úºñÄ«µå",
  4099: "ÆÄ»ç³ªÄ«µå",
  4100: "¼ÒÈñÄ«µå",
  4101: "»÷µå¸ÇÄ«µå",
  4102: "À§½ºÆÛÄ«µå",
  4103: "È£·ÕÄ«µå",
  4104: "·¹Äû¿¥Ä«µå",
  4105: "¸¶¸£Å©Ä«µå",
  4106: "¹ÌÀÌ¶óÄ«µå",
  4107: "º£¸´Æ®Ä«µå",
  4108: "¹Ì½ºÆ®Ä«µå",
  4109: "ÀèÄ«µå",
  4110: "±¸¿ïÄ«µå",
  4111: "½ºÆ®¶ó¿ìÇÁÄ«µå",
  4112: "¸¶¸£µÎÅ©Ä«µå",
  4113: "¸¶¸®¿À³×Æ®Ä«µå",
  4114: "¾Æ¸£Áö¿ÀÇÁÄ«µå",
  4115: "ÇåÅÍÇÃ¶óÀÌÄ«µå",
  4116: "ÀÌ½Ã½ºÄ«µå",
  4117: "½ÖµÎ¹ìÄ«µå",
  4118: "Áö»ó»Ú¶ìÄ«µå",
  4119: "¹Ù¼Ò¸®Ä«µå",
  4120: "°øÁß»Ú¶ìÄ«µå",
  4121: "ÇÁ¸®¿À´ÏÄ«µå",
  4122: "µ¥ºñ·çÄ¡Ä«µå",
  4123: "¿¡µå°¡Ä«µå",
  4124: "¸ÞµÎ»çÄ«µå",
  4125: "µ¥ºñ¾î½ºÄ«µå",
  4126: "È²¼ÒÄ«µå",
  4127: "³ªÀÌÆ®¸Þ¾îÄ«µå",
  4128: "±ÝµµµÏ¹ú·¹Ä«µå",
  4129: "¹ÙÆ÷ÁÖ´Ï¾îÄ«µå",
  4130: "½ºÄÝÇÇ¾ðÅ·Ä«µå",
  4131: "¿ù¾ßÈ­Ä«µå",
  4132: "¹Ì½ºÆ®·¹½ºÄ«µå",
  4133: "·¹ÀÌµå¸¯Ä«µå",
  4134: "µå¶óÅ¥¶óÄ«µå",
  4135: "¿ÀÅ©·ÎµåÄ«µå",
  4136: "½ºÄÌ³ªÀÌÆ®Ä«µå",
  4137: "µå·¹ÀÌÅ©Ä«µå",
  4138: "¾Æ´©ºñ½ºÄ«µå",
  4139: "Á¶Ä¿Ä«µå",
  4140: "Ä®¸®Ã÷¹ö±×Ä«µå",
  4141: "µå·çÀÌµåÄ«µå",
  4142: "µµÇÃ°»¾îÄ«µå",
  4143: "¿ÀÅ©È÷¾î·ÎÄ«µå",
  4144: "¿À½Ã¸®½ºÄ«µå",
  4145: "º£¸£Á¦ºêºêÄ«µå",
  4146: "¸¶¾ßÄ«µå",
  4147: "¹ÙÆ÷¸ÞÆ®Ä«µå",
  4148: "ÆÄ¶ó¿ÀÄ«µå",
  4149: "°¡°íÀÏÄ«µå",
  4150: "°í¿ìÆ®Ä«µå",
  4151: "°¡Á¶¸¶¸£Æ®Ä«µå",
  4152: "°¥¶óÆÄ°íÄ«µå",
  4153: "°ÔÄ«µå",
  4154: "°æ´Üµ¿ÀÚÄ«µå",
  4155: "°íºí¸°¸®´õÄ«µå",
  4156: "°íºí¸°½ºÆÀ¶óÀÌ´õÄ«µå",
  4157: "°íºí¸°¾ÆÃÄÄ«µå",
  4158: "°øÁßµô¸®ÅÍÄ«µå",
  4159: "±¸¹ÌÈ£Ä«µå",
  4160: "±¸½ÄÁ¶ÃÑº´Ä«µå",
  4161: "±×·£µåÆäÄÚÄ«µå",
  4162: "±×¸®Áñ¸®Ä«µå",
  4163: "±×¸®ÆùÄ«µå",
  4164: "±Û¸°ºÎ¸£½ºÆ¼Ä«µå",
  4165: "±â±×Ä«µå",
  4166: "³ªÀÌÆ®¸Þ¾îÅ×·¯Ä«µå",
  4167: "³×·¹ÀÌµåÄ«µå",
  4168: "´ÙÅ©·ÎµåÄ«µå",
  4169: "´ÙÅ©ÀÏ·çÁ¯Ä«µå",
  4170: "´ÙÅ©ÇÁ·¹ÀÓÄ«µå",
  4171: "´ÙÅ©ÇÁ¸®½ºÆ®Ä«µå",
  4172: "´õÆäÀÌÆÛÄ«µå",
  4173: "µ¥¸óÆã°Å½ºÄ«µå",
  4174: "µ¥ºô¸µÄ«µå",
  4175: "µ¶µÎ²¨ºñÄ«µå",
  4176: "µâ¶óÇÑÄ«µå",
  4177: "µå¶óÀÌ¾îµåÄ«µå",
  4178: "µå·¡°ïÅ×ÀÏÄ«µå",
  4179: "µå·¡°ïÇÃ¶óÀÌÄ«µå",
  4180: "µå¸±·¯Ä«µå",
  4181: "µð½º°¡ÀÌÁîÄ«µå",
  4182: "µð¾Æº¼¸¯Ä«µå",
  4183: "¶°µ¹ÀÌ´Á´ëÄ«µå",
  4184: "¶ó¹Ù°ñ·½Ä«µå",
  4185: "¶óÀÌµå¿öµåÄ«µå",
  4186: "·¹±Û·¯Ä«µå",
  4187: "·¹ÀÌµå¸¯¾ÆÃÄÄ«µå",
  4188: "·¹ÀÌºê¿Ã¸¶ÀÌÄ«µå",
  4189: "·¹ÀÌ½ºµ¥µåÄ«µå",
  4190: "·¹ÀÌ¾²Ä«µå",
  4191: "·Î¸®·ç¸®Ä«µå",
  4192: "·ÎÅÍÀÚÀÌ·ÎÄ«µå",
  4193: "·çµåÄ«µå",
  4194: "¸®ºñ¿ÀÄ«µå",
  4195: "¸®ÇÁÄ¹Ä«µå",
  4196: "¸¶¸°Ä«µå",
  4197: "¸¶½ºÅÍ¸µÄ«µå",
  4198: "¸¶¾ßÆÛÇÃÄ«µå",
  4199: "¸Ó¸ÇÄ«µå",
  4200: "¸Þ°¥¸®½ºÄ«µå",
  4201: "¸ÞÀÌÀú¿ì·Î½ºÄ«µå",
  4202: "¹¦±«Ä«µå",
  4203: "¹ÂÅÏÆ®µå·¡°í³ëÀÌµåÄ«µå",
  4204: "¹Ì´Ïµ¥¸óÄ«µå",
  4205: "¹Ì¹ÍÄ«µå",
  4206: "¹Ì½ºÆ®ÄÉÀÌ½ºÄ«µå",
  4207: "¹Ì½ºÆ¿Å×ÀÎÄ«µå",
  4208: "¹Ì¾ßºñÀÎÇüÄ«µå",
  4209: "¹ÙÀÌ¿Ã¸®Ä«µå",
  4210: "¹èÈ¸ÇÏ´ÂÀÚÄ«µå",
  4211: "º¸ÄÃÄ«µå",
  4212: "º»°ÇÄ«µå",
  4213: "ºê¸±¶óÀÌÆ®Ä«µå",
  4214: "ºí·¯µð¸Ó´õ·¯Ä«µå",
  4215: "ºí·¹ÀÌÀúÄ«µå",
  4216: "»ç½ºÄâÄ¡Ä«µå",
  4217: "»ýµµ¸ñÄ«µå",
  4218: "¼­Å¥¹ö½ºÄ«µå",
  4219: "¼¼ÀÌÁö¿úÄ«µå",
  4220: "¼Ö¸®´õÄ«µå",
  4221: "½ºÄÌ·¹ÅæÁ¦³×·²Ä«µå",
  4222: "½ºÄÌÇÁ¸®Áî³ÊÄ«µå",
  4223: "½ºÅÍ·¢Æ½°í·½Ä«µå",
  4224: "½ºÅÛ¿úÄ«µå",
  4225: "½ºÅæ½´ÅÍÄ«µå",
  4226: "½ºÆÃÄ«µå",
  4227: "½ºÇÁ¸µ·¡ºøÄ«µå",
  4228: "½½¸®ÆÛÄ«µå",
  4229: "½Ã°èÅ¾°ü¸®ÀÚÄ«µå",
  4230: "½Ã³ëºñÄ«µå",
  4231: "½Ä¾çÄ«µå",
  4232: "½Å¼±ÃÊÄ«µå",
  4233: "¾Æ±âÇ¥¹üÄ«µå",
  4234: "¾Æ³î¸®¾ÈÄ«µå",
  4235: "XMASÄíÅ°Ä«µå",
  4236: "¾Æ¸ó¶óÄ«µå",
  4237: "¾Æ¿ïµàÅ©Ä«µå",
  4238: "¾Æ¿ï¹Ù·ÐÄ«µå",
  4239: "¾ÆÀÌ¾ðÇÇ½ºÆ®Ä«µå",
  4240: "¾ÆÅ©¶ó¿ì½ºÄ«µå",
  4241: "¾ÆÅ©¿£Á©¸µÄ«µå",
  4242: "¾ÆÆ÷Ä®¸³½ºÄ«µå",
  4243: "¾ÈÅä´Ï¿ÀÄ«µå",
  4244: "¾Ë¶÷Ä«µå",
  4245: "¾Ï¹«Æ®Ä«µå",
  4246: "¾îÀýÅÍÄ«µå",
  4247: "¿¡½ºÅÍÄ«µå",
  4248: "¿¡ÀÎ¼ÇÆ®¹ÌÀÌ¶óÄ«µå",
  4249: "¿¡ÀÎ¼ÇÆ®¿úÄ«µå",
  4250: "¿¢¼­Å¥¼­³ÊÄ«µå",
  4251: "¿¤´õÄ«µå",
  4252: "¿¤¸®°ÔÀÌÅÍÄ«µå",
  4253: "¿¤¸®½ºÄ«µå",
  4254: "¿À¿ì°ÅÅõ½ºÄ«µå",
  4255: "¿ÀÅ©·¹ÀÌµðÄ«µå",
  4256: "¿ÀÅ©¾ÆÃÄÄ«µå",
  4257: "¿ÍÀÏµå·ÎÁîÄ«µå",
  4258: "¿ä¼±³àÄ«µå",
  4259: "¿ìµç°ñ·½Ä«µå",
  4260: "¿ìÅº½´ÅÍÄ«µå",
  4261: "¿ìÅºÆÄÀÌÅÍÄ«µå",
  4262: "¿î¾Ç¼±Ä«µå",
  4263: "¿ø·É¹«»çÄ«µå",
  4264: "À©µå°í½ºÆ®Ä«µå",
  4265: "ÀÌ¸Å¸Á·®Ä«µå",
  4266: "ÀÌÅ¬¸³½ºÄ«µå",
  4267: "ÀÍ½ºÇÃ·ÎÁ¯Ä«µå",
  4268: "ÀÎÀú½ºÆ¼½ºÄ«µå",
  4269: "ÀÎÅ¥¹ö½ºÄ«µå",
  4270: "ÀÚÀÌ¾ðÆ®½ºÆÄÀÌ´õÄ«µå",
  4271: "ÀÚÀÌ¾ðÆ®È£³ÝÄ«µå",
  4272: "ÀúÆÄ·æÄ«µå",
  4273: "Á¶°³Ä«µå",
  4274: "Á»ºñ¸¶½ºÅÍÄ«µå",
  4275: "Á»ºñÇÁ¸®Áî³ÊÄ«µå",
  4276: "Á×ÀºÀÚÀÇÁÖÀÎÄ«µå",
  4277: "Áö¸£Å¸½ºÄ«µå",
  4278: "ÁöºªÆ®Ä«µå",
  4279: "Áö»óµô¸®ÅÍÄ«µå",
  4280: "Áö¿À±×·¡ÆÛÄ«µå",
  4281: "ÁöÆÛº£¾îÄ«µå",
  4282: "Ãµ±¸Ä«µå",
  4283: "ÃµÇÏ´ëÀå±ºÄ«µå",
  4284: "Ã¼ÆêÆ®Ä«µå",
  4285: "ÃÝÄÚÄ«µå",
  4286: "Ä«¶óÄ«»çÄ«µå",
  4287: "Ä±ÆÄÄ«µå",
  4288: "Ä³·µÄ«µå",
  4289: "Ä³ÅÍÇÊ·¯Ä«µå",
  4290: "Ä¹¿À³ªÀÎÅ×ÀÏÄ«µå",
  4291: "ÄÚº¼Æ®¸®´õÄ«µå",
  4292: "ÄÚº¼Æ®¾ÆÃÄÄ«µå",
  4293: "ÄíÅ°Ä«µå",
  4294: "Å¥ºêÄ«µå",
  4295: "Å©¶óº¥Ä«µå",
  4296: "Å©·¥ÇÁÄ«µå",
  4297: "Å©·çÀÌÁ®Ä«µå",
  4298: "Å©¸®¹ÌÇÇ¾îÄ«µå",
  4299: "Å¬¶ôÄ«µå",
  4300: "Å°¸Þ¶óÄ«µå",
  4301: "Å³·¯¸ÇÆ¼½ºÄ«µå",
  4302: "Å¸¿À±ºÄ«Ä«µå",
  4303: "°Å´ëÀ§½ºÆÛÄ«µå",
  4304: "Å½·ç¾ÈÄ«µå",
  4305: "ÅÍÆ²Á¦³×·²Ä«µå",
  4306: "ÅäµåÄ«µå",
  4307: "Åõ±¸¹ú·¹Ä«µå",
  4308: "Æ®¶óÀÌÁ¶ÀÎÆ®Ä«µå",
  4309: "ÆÐ·¯»çÀÌÆ®Ä«µå",
  4310: "ÆÒÀú°íºí¸°Ä«µå",
  4311: "ÆÛ¸ÓÅÍÄ«µå",
  4312: "ÆÛ¾ÁÄ«µå",
  4313: "ÆãÅ©Ä«µå",
  4314: "Æä³ë¸Þ³ªÄ«µå",
  4315: "Æä½ºÆ®Ä«µå",
  4316: "ÆäÀÌÅ©¿£Á©Ä«µå",
  4317: "Æø·Â¹èÄ«µå",
  4318: "ÆøÇ³ÀÇ±â»çÄ«µå",
  4319: "ÇÁ¸®ÀúÄ«µå",
  4320: "ÇÇºûÀÇ±â»çÄ«µå",
  4321: "ÇÏÀÌ·ÎÁ¶ÀÌ½ºÆ®Ä«µå",
  4322: "ÇÏÀÌ¿ÀÅ©Ä«µå",
  4323: "ÇÏÆ¼º£º£Ä«µå",
  4324: "ÇÏÆ¼Ä«µå",
  4325: "ÇÏÇÇÄ«µå",
  4326: "ÇØ´ÞÄ«µå",
  4327: "Ç÷È£Á¢Ä«µå",
  4328: "Çý±ºÄ«µå",
  4329: "ÈÓ´Ù¸£Å©Ä«µå",
  4330: "Èæ»ç¿ÕÄ«µå",
  4331: "È÷ÅÍÄ«µå",
  4332: "°íÃ¶³­·Î",
  4333: "º£³ë¸Ó½º",
  4334: "³ì½Ã¾î½º",
  4335: "ÇÍ¸Ç",
  4336: "¿î°ñ¸®¾ÈÆ®",
  4337: "Æú¼¿¸®¿À",
  4338: "¿É½Ãµð¾ð",
  4339: "¹Ì³×¶ö",
  4340: "°õÀÎÇü",
  4341: "¸ÞÅ»¸µ",
  4342: "RSX0806Ä«µå",
  4343: "È¦µ§",
  4344: "À§·¹½ºÄ«µå",
  4345: "ÈúÀ©µåÄ«µå",
  4346: "ÀÌ±×´ÏÁª¼¼´Ï¾ÆÄ«µå",
  4347: "¾Æ¸£¸¶ÀÌ¾îµòÁ¦Ä«µå",
  4348: "ÈÖÄÉ¹ÙÀÎÆ®¸®½ºÄ«µå",
  4349: "ÀÌ·»µå¿¡º£½ÃÄ«µå",
  4350: "¶ó¿ì·¼ºá´õÄ«µå",
  4351: "Ä«¹ÙÅ©ÀÌÄ«·ç½ºÄ«µå",
  4352: "º¸½ºÀÌ±×´ÏÁªÄ«µå",
  4353: "¸®¹«¹öÄ«µå",
  4354: "Á¦¹Ì´Ï",
  4355: "±×·½¸°Ä«µå",
  4356: "ºñÈ¦´õ",
  4357: "·Îµå³ªÀÌÆ®Ä«µå",
  4358: "¼¼ÀÌ·»À©ÀúÄ«µå",
  4359: "¾î½Ø½ÅÅ©·Î½ºÄ«µå",
  4360: "¿¡·¹¸Þ½º°¡ÀÏÄ«µå",
  4361: "È­ÀÌÆ®½º¹Ì½ºÄ«µå",
  4362: "ÇÏ¿öµå¾ËÆ®¾ÆÀÌÁ¨Ä«µå",
  4363: "ÇÏÀÌÇÁ¸®½ºÆ®",
  4364: "¸¶°¡·¹Å¸¼Ò¸°Ä«µå",
  4365: "ÇÏÀÌÀ§ÀÚµåÄ«µå",
  4366: "Ä«Æ®¸°´ÀÄÉÀÌ·ÐÄ«µå",
  4367: "½º³ªÀÌÆÛÄ«µå",
  4368: "¼Î½Çµð¸ÕÄ«µå",
  4369: "º£³ªÅõ",
  4370: "µð¹ÌÅ©Ä«µå",
  4371: "¾ÆÅ©´ã",
  4372: "¹é¼ÒÁø",
  4373: "Ã»ÀÌ",
  4374: "º£½ºÆÛÄ«µå",
  4375: "¿ÀÅ©º£ÀÌºñ",
  4376: "Å¸´Ï¾Æ°¡¾¾",
  4377: "±×·Îºê",
  4378: "°ñµå¾î½Ã´õ½º",
  4379: "ºí·ç¾î½Ã´õ½ºÄ«µå",
  4380: "·¹µåÆä·¯½ºÄ«µå",
  4381: "±×¸°Æä·¯½ºÄ«µå",
  4382: "¿»·Î¿ì³ë¹ö½º",
  4383: "·¹µå³ë¹ö½º",
  4384: "ÇÏÀÌµå·Î·£¼­",
  4385: "µå·¡°ïÀÇ¾Ë",
  4386: "µðÅ¸¸£µ¥¿ì¸£½ºÄ«µå",
  4387: "¿¡ÀÎ¼ÇÆ®¹Ì¹Í",
  4388: "µ¥½º¿öµå",
  4389: "ÇÃ¶óÁî¸¶",
  4390: "»êµé¹Ù¶÷",
  4391: "½Å¹úÀÇ´ëÇàÀÚÄ«µå",
  4392: "°¨½ÃÇÏ´ÂÀÚÄ«µå",
  4393: "¾È½ÄÀ»ÁÖ´ÂÀÚÄ«µå",
  4394: "À§·ÎÇÏ´ÂÀÚ",
  4395: "Å¸³ªÅä½ºÀÇ½½ÇÄ",
  4396: "Å¸³ª³ë½ºÀÇÁõ¿À",
  4397: "Å¸³ªÅä½ºÀÇÀý¸Á",
  4398: "Å¸³ªÅä½ºÀÇ°í³ú",
  4399: "Å¸³ªÅä½ºÀÇ±â¾ïÄ«µå",
  4400: "¿¤¸®ÀÚ",
  4401: "¿¤¸®¼¿",
  4402: "¿¤¸®¾ù",
  4403: "Å°¿¤Ä«µå",
  4404: "½ºÄÚ±Û",
  4405: "ÇÁ·ç½º",
  4406: "½ºÄÉ°ñÆ®",
  4407: "¶õµå±×¸®½º",
  4408: "±Û·ë¾ð´õ³ªÀÌÆ®Ä«µå",
  4409: "¾Æ°¡ºêÄ«µå",
  4410: "¿¡Å°¿ÀÄ«µå",
  4411: "ÆÇº£¸£Å©Ä«µå",
  4412: "ÀÌ½Ç¶óÄ«µå",
  4413: "È£µå·½¸°Ä«µå",
  4414: "½ÃÄ¿Ä«µå",
  4415: "½º³ëÀÌ¾îÄ«µå",
  4416: "½Ã·Î¸¶Ä«µå",
  4417: "¾ÆÀÌ½ºÆ¼ÅºÄ«µå",
  4418: "°¡¿¡ÁîÆ¼Ä«µå",
  4419: "Å©Åø¶ó³«½ºÄ«µå",
  4420: "¸Ó½ºÅ°Ç½¶óÄ«µå",
  4421: "µå·Î¼¼¶óÄ«µå",
  4422: "·Î¿ìÀ©Ä«µå",
  4423: "°¥¸®¿ÂÄ«µå",
  4424: "½ºÅÂÆ÷Ä«µå",
  4425: "¾ÆÆ®·Î½ºÄ«µå",
  4426: "ºÌ¸£±×Ä«µå",
  4427: "¼Òµå°¡µð¾ðÄ«µå",
  4428: "º¸¿ì°¡µð¾ðÄ«µå",
  4429: "»ø·¯¸Ç´õÄ«µå",
  4430: "ÀÌÇÁ¸®Æ®Ä«µå",
  4431: "Ä«»çÄ«µå",
  4432: "¸¶±×¸¶¸µÄ«µå",
  4433: "ÀÓÇÁÄ«µå",
  4434: "³ìÄ¿Ä«µå",
  4435: "Á»ºñ½½·¯ÅÍÄ«µå",
  4436: "´©´õ±âÁ»ºñÄ«µå",
  4437: "ÇïÇªµéÄ«µå",
  4438: "¹ê½ÃÄ«µå",
  4439: "ÇÃ·¹ÀÓ½ºÄÃÄ«µå",
  4440: "³×Å©·Î¸Ç¼­Ä«µå",
  4441: "Å¸¶ôÇÑ´ë½Å°üÄ«µå",
  4442: "µûµûÃÊÄ«µå",
  4443: "¾ÆÄí¾Æ¿¤·¹¸àÅ»Ä«µå",
  4444: "µå¶óÄÚÄ«µå",
  4445: "·ç½Ã¿Ã¶óº£½ºÆÄÄ«µå",
  4447: "¼¾Æ¼Æäµ¥Ä«µå",
  4448: "ÄÚ¸£´©½ºÄ«µå",
  4449: "´ÙÅ©½¦µµ¿ìÄ«µå",
  4450: "¹ê½Ã¸¶½ºÅÍÄ«µå",
  4451: "¿£Æ®¹ÙÀÌ¿£Ä«µå",
  4452: "¼¾Æ¼Æäµ¥À¯ÃæÄ«µå",
  4453: "Èú½º¸®¿ÂÄ«µå",
  4454: "¹àÈ÷¸®Ä«µå1",
  4455: "¹àÈ÷¸®Ä«µå2",
  4478: "¹àÈ÷¸®Ä«µå3",
  4479: "¹àÈ÷¸®Ä«µå4",
  4456: "´ÏµåÈ£±×ÀÇ±×¸²ÀÚÄ«µå",
  4457: "³ªÈåÆ®Áö°ÅÄ«µå",
  4458: "µÎ³×ÀÌ¸£Ä«µå",
  4459: "¶óÅ¸Ä«µå",
  4460: "¸µÄÚÄ«µå",
  4461: "ÇÊ¶óÄ«µå",
  4462: "ÇÏµå¶ô¸¾¸ð½ºÄ«µå",
  4463: "ÅÙµå¸±¸®¿ÂÄ«µå",
  4464: "¾Æ¿ì³ë¿¡Ä«µå",
  4465: "ÆÄ³ªÆ®Ä«µå",
  4466: "ºñÈ¦´õ¸¶½ºÅÍÄ«µå",
  4467: "Çìºñ¸ÞÅ»¸µÄ«µå",
  4468: "ÇÉ±ÍÅ§¶ó´ÙÅ©Ä«µå",
  4469: "³ª°¡Ä«µå",
  4470: "³×Ææµ¥½ºÄ«µå",
  4471: "µå¶óÄÚÀÇ¾ËÄ«µå",
  4472: "ºê¶óµð¿ò°í·½Ä«µå",
  4473: "¿¡ÀÎ¼ÇÆ®Æ®¸®Ä«µå",
  4474: "ÀÚÄí´ãÄ«µå",
  4475: "ÄÚ¹ßÆ®¹Ì³×¶öÄ«µå",
  4476: "ÇÉ±ÍÅ§¶óÄ«µå",
  4477: "Çï¾ÆÆ÷Ä®¸³½ºÄ«µå",
  4505: "½ºÄ«¶ó¹ÙÄ«µå",
  4506: "µ¹·Î¸Þµ¥½ºÄ«µå",
  4507: "¿©¿Õ½ºÄ«¶ó¹ÙÄ«µå",
  4508: "È²±Ý½ºÄ«¶ó¹ÙÄ«µå",
  4509: "È²±Ý¿©¿Õ½ºÄ«¶ó¹ÙÄ«µå",
  4510: "¹Ì¹ÖÄ«µå",
  4511: "²¿¸¶ÆÄÅùÄ«µå",
  4512: "ÆÄ·ç½ºÄ«µå",
  4513: "¾Ó±×¶ó¸ÇÆ¼½ºÄ«µå",
  4514: "Æû½ºÆÄÀÌ´õÄ«µå",
  4515: "¶óÇÃ·¹½Ã¾Æ¾Ë³îµðÄ«µå",
  4516: "ÄÚ¸ðµµÄ«µå",
  4517: "¼¾µå¶ó¿Í½ÃÄ«µå",
  4518: "¹Ù³ª½ºÆÄÆ¼Ä«µå",
  4519: "ºÎÅäÀÌÁ¶Ä«µå",
  4520: "¹«½Ã¹«½ÃÇÑ¸¯Ä«µå",
  4521: "¼¼µµ¶óÄ«µå",
  4522: "½º·ÎÆ÷Ä«µå",
  4523: "µµÇÁ·¹Ç×¾Æ¸®Ä«µå",
  4524: "Å·µå¶ó¸ðÄ«µå",
  4525: "Å©¶óÄËÄ«µå",
  4526: "±«ÀÌÇÑ½Ç·¯Äµ½ºÄ«µå",
  4527: "¾ÏÈæÀÇ½Ç·¯Äµ½ºÄ«µå",
  4528: "µ¹¿¬º¯ÀÌ½Ç·¯Äµ½ºÄ«µå",
  4529: "Æ÷¾ÇÇÑ½Ç·¯Äµ½ºÄ«µå",
  4530: "½Ã¿À¶ó¹ÙÄ«µå",
  4531: "»¡°­¿¡·ç¸¶Ä«µå",
  4532: "¿ÍÀÏµå¶óÀÌ´õÄ«µå",
  4533: "ÀÛÀº¹®¾îÄ«µå",
  4534: "´ë¿Õ¹®¾îÄ«µå",
  4545: "Æ÷¸µÄ«µå",
  4546: "¹àÈ÷¸®Ä«µå5",
  4488: "ºÀÀÎµÈ´ÙÅ©·ÎµåÄ«µå",
  4480: "ºÀÀÎµÈÅ°¿¤_D_01Ä«µå",
  4481: "ºÀÀÎµÈÅ©Åø¶ó³«½ºÄ«µå",
  4482: "ºÀÀÎµÈº¸½ºÀÌ±×´ÏÁªÄ«µå",
  4483: "ºÀÀÎµÈµå¶óÅ¥¶óÄ«µå",
  4484: "ºÀÀÎµÈ¹Ì½ºÆ®·¹½ºÄ«µå",
  4485: "ºÀÀÎµÈ±Û·ëÄ«µå",
  4486: "ºÀÀÎµÈº£¸£Á¦ºêºêÄ«µå",
  4487: "ºÀÀÎµÈÀÌÇÁ¸®Æ®Ä«µå",
  4489: "ºÀÀÎµÈÆÄ¶ó¿ÀÄ«µå",
  4490: "ºÀÀÎµÈ¿ù¾ßÈ­Ä«µå",
  4491: "ºÀÀÎµÈ½º³ªÀÌÆÛÄ«µå",
  4492: "ºÀÀÎµÈ¿ÀÅ©È÷¾î·ÎÄ«µå",
  4493: "ºÀÀÎµÈÅ¸¿À±ºÄ«Ä«µå",
  4494: "ºÀÀÎµÈÅÍÆ²Á¦³×·²Ä«µå",
  4495: "ºÀÀÎµÈ¾Æ¸ó¶óÄ«µå",
  4496: "ºÀÀÎµÈµå·¹ÀÌÅ©Ä«µå",
  4497: "ºÀÀÎµÈÆøÇ³ÀÇ±â»çÄ«µå",
  4498: "ºÀÀÎµÈÅ¸´Ï¾Æ°¡¾¾Ä«µå",
  4499: "ºÀÀÎµÈ¿ø·É¹«»çÄ«µå",
  4500: "ºÀÀÎµÈ¿ÀÅ©·ÎµåÄ«µå",
  4501: "ºÀÀÎµÈÇÏÀÌÇÁ¸®½ºÆ®Ä«µå",
  4502: "ºÀÀÎµÈÈ­ÀÌÆ®½º¹Ì½ºÄ«µå",
  4503: "ºÀÀÎµÈº£½ºÆÛÄ«µå",
  4504: "ºÀÀÎµÈ¿¡µå°¡Ä«µå",
  4535: "ºÀÀÎµÈ¶õµå±×¸®½ºÄ«µå",
  4536: "ºÀÀÎµÈ¾ÆÆ®·Î½ºÄ«µå",
  4537: "ºÀÀÎµÈÇÁ¸®¿À´ÏÄ«µå",
  4538: "ºÀÀÎµÈ¹é¼ÒÁøÄ«µå",
  4539: "ºÀÀÎµÈÅ¸¶ôÇÑ´ë½Å°üÄ«µå",
  4540: "ºÀÀÎµÈÁ×ÀºÀÚÀÇÁÖÀÎÄ«µå",
  4541: "ºÀÀÎµÈÇÏÀÌÀ§ÀÚµåÄ«µå",
  4542: "ºÀÀÎµÈµðÅ¸¸£Ä«µå",
  4543: "ºÀÀÎµÈÇÏÆ¼Ä«µå",
  4544: "ºÀÀÎµÈÈæ»ç¿ÕÄ«µå",
  4556: "Ææ¸±Ä«µå",
  4557: "¾àÈ­µÈÆæ¸±Ä«µå",
  4559: "Àý¸ÁÀÇ½Å¸ð·ÎÅ©Ä«µå",
  4587: "Æ¼¾ï†¤Ä«µ",
  4908: "¸¶½ÅÀÇÁ¤¼öÄ«µå1",
  4909: "¸¶½ÅÀÇÁ¤¼öÄ«µå1",
  4910: "¸¶½ÅÀÇÁ¤¼öÄ«µå2",
  4911: "¸¶½ÅÀÇÁ¤¼öÄ«µå1",
  4912: "¸¶½ÅÀÇÁ¤¼öÄ«µå1",
  4913: "¸¶½ÅÀÇÁ¤¼öÄ«µå2",
  4914: "¸¶½ÅÀÇÁ¤¼öÄ«µå1",
  4915: "¸¶½ÅÀÇÁ¤¼öÄ«µå1",
  4916: "¸¶½ÅÀÇÁ¤¼öÄ«µå2",
  4917: "¸¶½ÅÀÇÁ¤¼öÄ«µå1",
  4918: "¸¶½ÅÀÇÁ¤¼öÄ«µå1",
  4919: "¸¶½ÅÀÇÁ¤¼öÄ«µå2",
  4920: "¸¶½ÅÀÇÁ¤¼öÄ«µå1",
  4921: "¸¶½ÅÀÇÁ¤¼öÄ«µå1",
  4922: "¸¶½ÅÀÇÁ¤¼öÄ«µå2",
  4923: "¸¶½ÅÀÇÁ¤¼öÄ«µå1",
  4924: "¸¶½ÅÀÇÁ¤¼öÄ«µå1",
  4925: "¸¶½ÅÀÇÁ¤¼öÄ«µå2",
  4560: "Å©·Î¿îÄ«µå",
  4561: "ÇÁ·ÎÆä¼­Ä«µå",
  4562: "Ã¨ÇÇ¾ðÄ«µå",
  4563: "Å©¸®¿¡ÀÌÅÍÄ«µå",
  4564: "½ºÅäÄ¿Ä«µå",
  4565: "ÆÈ¶óµòÄ«µå",
  4566: "Áý½ÃÄ«µå",
  4567: "¾Æ¸£º¸Ä¡¿À¹Ù½ÇÄ«µå",
  4568: "½Ç¸®¾Æ¾Ëµ¥Ä«µå",
  4569: "Ã¾¸®¿ìÄ«µå",
  4570: "ÇÃ¶ó¸áÀÌ¹ÄÄ«µå",
  4571: "°ÅÆ¼À§Ä«µå",
  4572: "·£´Þ·Î·»½ºÄ«µå",
  4573: "Æ®·»Æ¼´ÏÄ«µå",
  4574: "Àå±º´ëÇöÄ«µå",
  4575: "È£À§¹«»ç¼ÒÇöÄ«µå",
  4576: "Áö¿ÀÀÌ¾ÆÄ«µå",
  4577: "¿¤ºñ¾ÆÄ«µå",
  4578: "Å»¶ôÀÚÇ»¸®¿¤Ä«µå",
  4579: "¿©Àü»ç·Î¶óÄ«µå",
  4580: "¼öÈ£ÀÚÄ«µ¥½ºÄ«µå",
  4581: "·çµµÄ«µå",
  4582: "ºØÀÌ½ÂÀÌ½ºÄ«µå",
  4583: "¿¨ÄÁÅäÄ«µå",
  4584: "¸Ó³Ê³Õ°ÉÄ«µå",
  4585: "¸ÛÄíÄí·³Ä«µå",
  4586: "Æ½¹ö··Ä«µå",
  4588: "ŸpŸpÄ«µå",
  4589: "Á¦Á¦¸µÄ«µå",
  4590: "º¡¿õ°÷Ä«µå",
  4591: "¹öÄÚ³Ê¿öÄ«µå",
  4592: "ºÎ¿ö¿©Ä«µå",
  4593: "¸Çºí¸´Ä«µå",
  4594: "ÆäÅ»Ä«µå",
  4595: "Ã¼³×·¹Ä«µå",
  4596: "ÈÑ¼ÕµÈ°í¼­Ä«µå",
  4597: "ÆÄ¶û¸®È÷Å×¸¥Ä«µå",
  4598: "ÃÊ·Ï¸®È÷Å×¸¥Ä«µå",
  4599: "»¡°­¸®È÷Å×¸¥Ä«µå",
  4600: "°¥»ö¸®È÷Å×¸¥Ä«µå",
  4601: "¾Ï´Ù¶óÀÌ½ºÄ«µå",
  4602: "°¢¼º¾Ï´Ù¶óÀÌ½ºÄ«µå",
  4603: "Å¸¶ôÇÑ»Ñ¸®Ä«µå",
  4604: "°¢¼ºÅ¸¶ôÇÑ»Ñ¸®Ä«µå",
  4605: "°íÅëÀÇ±â»çÄ«µå",
  4606: "¿øÇÑÀÇ±â»çÄ«µå",
  4607: "¼º½ÇÇÑ´«µ¿ÀÚÄ«µå",
  4610: "»ç¶óÄ«µå",
  4611: "RO¼Ò³à¾Æ¹Ì½ºÄ«µå",
  4612: "RO¼Ò³à¹Ì¾ÆÄ«µå",
  4613: "RO¼Ò³à¼Ò¹üÄ«µå",
  4614: "RO¼Ò³à¼Ò¿ìÄ«µå",
  4615: "RO¼Ò³à¼Ò¿¬Ä«µå",
  4616: "RO¼Ò³à¼Ò¿ùÄ«µå",
  4617: "RO¼Ò³àÀÌÀÌÄ«µå",
  4618: "RO¼Ò³àÄ¹½ÃÄ«µå",
  4619: "RO¼Ò³àÇÇÇÇÄ«µå",
  4620: "RO¼Ò³à¿¹»ßÄ«µå",
  4621: "RO¼Ò³àÁø¿µÄ«µå",
  4622: "RO¼Ò³à´ÞÄÞÄ«µå",
  4608: "¹é»öÀÇ±â»ç´ÜÄ«µå",
  4609: "Ä®¸®Ã÷±â»ç´ÜÄ«µå",
  4551: "°­È­³×Å©·Î¸Ç¼­Ä«µå",
  4625: "Å¸ÀÓÈ¦´õÄ«µå",
  4626: "ºòº¥Ä«µå",
  4627: "ºòº§Ä«µå",
  4628: "³×¿ÀÆãÅ©Ä«µå",
  4629: "¾ÆÅ©¿¤´õÄ«µå",
  4630: "Å¸ÀÓÅ°ÆÛÄ«µå",
  4631: "¾Æ¿ï¹ÙÀÌÄ«¿îÆ®Ä«µå",
  4632: "¾Æ¿ï¸¶Äû½ºÄ«µå",
  4446: "°­È­½ºÄÌ·¹ÅæÄ«µå",
  4633: "°­È­¾ÆÃÄ½ºÄÌÅæÄ«µå",
  4634: "°­È­¼ÖÁ®½ºÄÌÅæÄ«µå",
  4635: "°­È­¾Ï´Ù¶óÀÌ½ºÄ«µå",
  4636: "ºñÁêÄ«µå",
  4637: "ºÒ»çÀÇ±º´ÜÄ«µå",
  4638: "¿ÍÃÄÄ«µå",
  4639: "ÅÂÇÇÄ«µå",
  4640: "ÇÁ·ÎÁð¿ïÇÁÄ«µå",
  4641: "µÇ»ì¾Æ³­°æºñº´Ä«µå",
  4652: "±×·¹ÀÌºê¾Æ¸ó¶óÄ«µå",
  4653: "±×·¹ÀÌºê¾ÆÅ©¶ó¿ì½ºÄ«µå",
  4654: "±×·¹ÀÌºê¹Ì¹ÍÄ«µå",
  4655: "±×·¹ÀÌºê¸¶ÀÌ³ÊÄ«µå",
  4656: "±×·¹ÀÌºê¹ÌÀÌ¶óÄ«µå",
  4657: "±×·¹ÀÌºê¿£¼ÇÆ®¹Ì¶óÄ«µå",
  4658: "±×·¹ÀÌºêº£¸´Æ®Ä«µå",
  4659: "¿¡±×¸µÄ«µå",
  4660: "Á¤Âû¹ÙÁú¸®½ºÅ©Ä«µå",
  4661: "µ¹°Ý¹ÙÁú¸®½ºÅ©Ä«µå",
  4662: "´ëÇü¿¡±×¸µÄ«µå",
  4642: "¹«ÇÑÅäµåÄ«µå",
  4643: "¹«ÇÑ¶°µ¹ÀÌ´Á´ëÄ«µå",
  4644: "¹«ÇÑº¸ÄÃÄ«µå",
  4645: "¹«ÇÑÀÌÅ¬¸³½ºÄ«µå",
  4646: "¹«ÇÑÅ°¸Þ¶óÄ«µå",
  4647: "¹«ÇÑ¿À½Ã¸®½ºÄ«µå",
  4648: "¹«ÇÑ¿¡µå°¡Ä«µå",
  4649: "¹«ÇÑÇÁ¸®¿À´ÏÄ«µå",
  4650: "¹«ÇÑ¿ÀÅ©È÷¾î·ÎÄ«µå",
  4651: "¹«ÇÑÅ¸¿À±ºÄ«Ä«µå",
  4663: "¸®ÇÁ·ç³ªÆ½Ä«µå",
  4664: "±×·¡½ºÆÄºê¸£Ä«µå",
  4665: "¿ÍÀÏµåÈ£³ÝÄ«µå",
  4666: "½ºÀ§Æ®·Î´ÙÇÁ·Î±×Ä«µå",
  4667: "ÇåÅÍµ¥ÀúÆ®¿ïÇÁÄ«µå",
  4668: "Æ®·£½º½ºÆ÷¾ÆÄ«µå",
  4669: "Á¤±Û¸¸µå¶ó°í¶óÄ«µå",
  4670: "ÇÁ·çÃ÷Æû½ºÆÄÀÌ´õÄ«µå",
  31006: "LoVAÇÏµ¥½ºÄ«µå",
  31007: "LoVAÁøÈ­ÇÏµ¥½ºÄ«µå",
  31008: "LoVA·ç·çÄ«µå",
  31009: "LoVAÁøÈ­·ç·çÄ«µå",
  31010: "LoVAÅ°¸¶Ä«µå",
  31011: "LoVAÁøÈ­Å°¸¶Ä«µå",
  31012: "LoVA¹ÙÇÏ¹«Æ®Ä«µå",
  31013: "LoVAÁøÈ­¹ÙÇÏ¹«Æ®Ä«µå",
  31014: "LoVA¶ó±×³ª·ÎÅ©Ä«µå",
  31015: "LoVAÁøÈ­¶ó±×³ª·ÎÅ©Ä«µå",
  31000: "·çµµÄ«µå",
  31001: "¿©Àü»ç·Î¶óÄ«µå",
  31002: "¿¤ºñ¾ÆÄ«µå",
  31003: "Áö¿ÀÀÌ¾ÆÄ«µå",
  31004: "È£À§¹«»ç¼ÒÇöÄ«µå",
  31005: "Àå±º´ëÇöÄ«µå",
  4671: "¼Ò¼­·¯Ä«µå",
  4672: "¼ö¶óÄ«µå",
  4673: "¹Î½ºÆ®·²Ä«µå",
  4674: "±æ·ÎÆ¾Å©·Î½ºÄ«µå",
  4675: "¾ÆÅ©ºñ¼óÄ«µå",
  4676: "·¹ÀÎÀúÄ«µå",
  4677: "¹ÌÄÉ´ÐÄ«µå",
  4678: "¿ö·ÏÄ«µå",
  4679: "·é³ªÀÌÆ®Ä«µå",
  4680: "·Î¿­°¡µåÄ«µå",
  4681: "Á¦³×¸¯Ä«µå",
  4682: "½¦µµ¿ìÃ¼ÀÌ¼­Ä«µå",
  4683: "¿ø´õ·¯Ä«µå",
  4684: "Áø¿¡·¹¸Þ½º°¡ÀÏÄ«µå",
  4685: "Áø¸¶°¡·¹Å¸¼Ò¸°Ä«µå",
  4686: "ÁøÄ«Æ®¸°´ÀÄÉÀÌ·ÐÄ«µå",
  4687: "Áø¼Î½Çµð¸ÕÄ«µå",
  4688: "ÁøÇÏ¿öµå¾ËÆ®¾ÆÀÌÁ¨Ä«µå",
  4689: "Áø¼¼ÀÌ·»À©ÀúÄ«µå",
  4690: "Áø·£´Þ·Î·»½ºÄ«µå",
  4691: "ÁøÇÃ¶ó¸áÀÌ¹ÄÄ«µå",
  4692: "Áø½Ç¸®¾Æ¾Ëµ¥Ä«µå",
  4693: "ÁøÃ¾¸®¿ìÄ«µå",
  4694: "Áø°ÅÆ¼À§Ä«µå",
  4695: "ÁøÆ®·»Æ¼´ÏÄ«µå",
  4696: "Áø¾Æ¸£º¸Ä¡¿À¹Ù½ÇÄ«µå",
  31024: "ºÒ¸êÀÇÀúÁÖ¹ÞÀº±â»çÄ«µå",
  31025: "ºÒ¸êÀÇÀ©µå°í½ºÆ®Ä«µå",
  31026: "½ºÅ×ÆÇÄ«µå",
  31016: "Àå½ÄµÈ¾Ç·É³ª¹«Ä«µå",
  31017: "Æ÷¾ÇÇØÁøÄíÅ°Ä«µå",
  31018: "¾Ç·É±êµç»óÀÚÄ«µå",
  31019: "¼¶¶àÇÑ¾Ç·ÉÄ«µå",
  31020: "¾ÇÀÇ¿¡ÂùÀ¯·ÉÄ«µå",
  31021: "ÃãÃß´Â¸¶¸®¿À³×Æ®Ä«µå",
  31022: "¹ö·ÁÁø°õÀÎÇüÄ«µå",
  31023: "¼¿¸°´ÀÅ°¹ÌÄ«µå",
  27012: "Å±½ºÅÜÄ«µå",
  27013: "Å±¾ØÅ±Ä«µå",
  27014: "±×¸°Ã¼³×·¹Ä«µå",
  27015: "¼ö¸®·Îº¿ÅÍº¸Ä«µå",
  27016: "Å½»ç·Îº¿ÅÍº¸Ä«µå",
  27017: "°íÃ¶·Îº¿Ä«µå",
  27018: "GC109Ä«µå",
  27019: "DR815Ä«µå",
  27020: "T_W_OÄ«µå",
  4697: "Âû½ºÅÏÄ«µå",
  4698: "½ºÅÜÄ«µå",
  4699: "¶ô½ºÅÜÄ«µå",
  29230: "JP_EV02",
  27021: "JP_EV03",
  27022: "JP_EV04",
  27023: "JP_EV05",
  27024: "JP_EV06",
  27026: "È­¿°ÄÜµµ¸£Ä«µå",
  27027: "È­¿°»÷µå¸ÇÄ«µå",
  27028: "È­¿°ÇÁ¸±µµ¶óÄ«µå",
  27029: "È­¿°°í·½Ä«µå",
  27030: "ºÒ¹÷Ä«µå",
  27031: "¹Ì±ÃÀÇ¹ÙÆ÷¸ÞÆ®Ä«µå",
  27032: "¹Ì±ÃÀÇµå¶óÅ¥¶óÄ«µå",
  27025: "¸ÁÀÚÀÇ±ºÁÖÄ«µå",
  27050: "¾Ö´Ï¹ö¼­¸®Ä«µå1",
  27051: "¾Ö´Ï¹ö¼­¸®Ä«µå2",
  27052: "¾Ö´Ï¹ö¼­¸®Ä«µå3",
  27053: "¾Ö´Ï¹ö¼­¸®Ä«µå4",
  27054: "¾Ö´Ï¹ö¼­¸®Ä«µå5",
  27081: "ºÐ³ëÇÑ¿ù¾ßÈ­Ä«µå",
  27082: "ºÐ³ëÇÑ±¸¹ÌÈ£Ä«µå",
  27083: "¿øÅëÇÑº»°ÇÄ«µå",
  27084: "¿øÅëÇÑ¼ÒÈñÄ«µå",
  27085: "¿øÅëÇÑ¹«³«Ä«µå",
  27086: "¿øÅëÇÑ¾ÆÃÄ½ºÄÌÄ«µå",
  27087: "Áø¸®ÀÇ¸¶¹ý»çÄ«µå",
  27088: "±¤±âÀÇ¸ðÇè°¡Ä«µå",
  27101: "½ºÀ§Æ®³ª¸ÞÀÌÆ®¸Þ¾îÄ«µå",
  27102: "¸ÅÆ®µå·¹ÀÎ¸®¾îÄ«µå",
  27103: "¾È½ÄÀ»»©¾Ñ±äÀÚÄ«µå",
  27104: "ºÐ³ëÇÑµå¶óÅ¥¶óÄ«µå",
  27105: "º¸¹ÌÄ«µå",
  27106: "°¢¼ºÇÑÆä¸£Ä«µå",
  27107: "¿¬ÁÖÇÏ´ÂÆä¸£Ä«µå",
  27108: "³ë·¡ÇÏ´ÂÆä¸£Ä«µå",
  27109: "ÁöÅÍ¹÷Ä«µå",
  27110: "ºÐ³ëÇÑ°Ô¿¡ÁîÆ¼Ä«µå",
  27111: "ºÐ³ëÇÑ½º³ëÀÌ¾îÄ«µå",
  27112: "ºÐ³ëÇÑ¾ÆÀÌ½ºÆ¼ÅºÄ«µå",
  27113: "±ú¾î³­Å©Åø¶ó³«½ºÄ«µå",
  27127: "°í´ë¿Õ±×·ÎÀÚÄ«µå",
  27128: "½ÉÃþÀÇ°í´ë¿Õ±×·ÎÀÚÄ«µå",
  27129: "Á¤ÀÇÀÇÄ«µå",
  27130: "º°ÀÇÄ«µå",
  27131: "ÀýÁ¦ÀÇÄ«µå",
  27132: "ÀüÂ÷ÀÇÄ«µå",
  27133: "»ç½ÅÀÇÄ«µå",
  27134: "ÀºÀÚÀÇÄ«µå",
  27135: "È²Á¦ÀÇÄ«µå",
  27136: "´ÞÀÇÄ«µå",
  27137: "¿¬ÀÎÀÇÄ«µå",
  27138: "¹ýÈ²ÀÇÄ«µå",
  27139: "¾Ç¸¶ÀÇÄ«µå",
  27140: "ÈûÀÇÄ«µå",
  27114: "ºÒ±æÇÑ¼Ö¸®´õÄ«µå",
  27115: "ºÒ±æÇÑÆÛ¸ÓÅÍÄ«µå",
  27116: "ºÒ±æÇÑÈ÷ÅÍÄ«µå",
  27117: "ºÒ±æÇÑ¾îÀýÅÍÄ«µå",
  27118: "ºÒ±æÇÑÇÁ¸®ÀúÄ«µå",
  27119: "ºÒ±æÇÑÅÍÆ²Á¦³×·²Ä«µå",
  27120: "ÀÌ¾Æ¶óÄ«µå",
  27121: "ÇÇ¶ó´Ï¾ÆÄ«µå",
  27122: "Äí·çÇÇ¶óÄ«µå",
  27123: "ÅõÄ­Ä«µå",
  27124: "Àç±Ô¾îÄ«µå",
  27125: "¸Ó¸®¾ø´Â¸»Ä«µå",
  27126: "º¸ÀÌÅ¸Å¸Ä«µå",
  27147: "Human_Kimera_Card",
  27148: "Matter_Kimera_Card",
  27149: "Heart_Hunter_Card",
  27150: "Venom_Kimera_Card",
  27151: "Evil_Card",
  27152: "Cutie_Card",
  27153: "±ÝµµµÏ¹ú·¹Ä«µå",
  27154: "¸¶¾ßÄ«µå",
  27206: "µµÇÃ°»¾îÄ«µå",
  27207: "¿ù¾ßÈ­Ä«µå",
  27208: "¿À½Ã¸®½ºÄ«µå",
  27266: "ÇåÅÍÇÃ¶óÀÌÄ«µå",
  27267: "ÇÁ¸®¿À´ÏÄ«µå",
  27268: "µå¶óÅ¥¶óÄ«µå",
  27269: "ÆøÇ³ÀÇ±â»çÄ«µå",
  27157: "Wood_Goblin_Card",
  27158: "Les_Card",
  27159: "Uzhas_Card",
  27160: "Vavayaga_Card",
  27161: "Mavka_Card",
  27162: "Gopinich_Card",
  27163: "Faceworm_Card",
  27164: "Faceworm_Q_Card",
  27165: "Faceworm_D_Card",
  27166: "Faceworm_Egg_Card",
  27167: "Faceworm_L_Card",
  27168: "Irene_Elder_Card",
  27169: "Payon_Soldier_Card",
  27181: "AirShip_Raid_Card",
  27182: "Felock_Card",
  27183: "Gigantes_Card",
  27184: "Knight_Sakray_Card",
  27196: "S_Nihil_Card",
  27197: "S_Agnes_Card",
  27198: "S_Jurgen_Card",
  27199: "S_Spica_Card",
  27200: "Nihil_Card",
  27201: "Agnes_Card",
  27202: "Jurgen_Card",
  27203: "Spica_Card",
  27330: "Kronecker_Card",
  27331: "S_Kronecker_Card",
  27332: "Skia_Card",
  27333: "S_Skia_Card",
  300127: "Wolf_Card_E",
  300128: "S_Wolf_Card",
  300129: "Poe_Card",
  300130: "S_Poe_Card",
  27389: "Wolf_Card_E",
  27390: "S_Wolf_Card",
  27391: "Poe_Card",
  27392: "S_Poe_Card",
  27209: "SLD_Q_Scaraba_Card",
  27210: "SLD_Thanatos_Card",
  27211: "SLD_Baphomet_Card",
  27212: "SLD_Maya_Card",
  27213: "SLD_Clown_Card",
  27214: "SLD_Professor_Card",
  27215: "SLD_Champion_Card",
  27216: "SLD_Creator_Card",
  27217: "SLD_Stalker_Card",
  27218: "SLD_Paladin_Card",
  27219: "SLD_Gypsy_Card",
  27220: "SLD_Daehyon_Card",
  27221: "SLD_Gioia_Card",
  27222: "SLD_Pyuriel_Card",
  27224: "SLD_Kades_Card",
  27225: "SLD_Timeholder_Card",
  27170: "Cowraiders1_Card",
  27171: "Cowraiders2_Card",
  27172: "Cowraiders3_Card",
  27173: "E_Cowraiders1_Card",
  27174: "E_Cowraiders2_Card",
  27175: "E_Cowraiders3_Card",
  27176: "Rr_Cramp_Card",
  27177: "Rr_Arclouse_Card",
  27178: "Gaster_Card",
  27179: "Coyote_Card",
  27180: "Mechaspider_Card",
  27249: "¾Æ¸£È÷Ä«µå",
  27250: "µð¿À¾Æ³×¸ð½ºÄ«µå",
  27251: "°ÔÆæ±øÆÐÄ«µå",
  27252: "°ÔÆæºÒ·®¹èÄ«µå",
  27253: "°ÔÆæÁ»µµµÏÄ«µå",
  27254: "Æä¸ùÄ«µå",
  27255: "¿À¸£µå¸£Ä«µå",
  27256: "ºí·çÆ®ÇÏÁ¦Ä«µå",
  27257: "Äí·Î¾ÆÄí¸¶Ä«µå",
  27258: "ÀÌÆ÷´õ½ºÄ«µå",
  27259: "·¹Ã¼´Ï¿¹Ä«µå",
  27260: "¿Àµµ¸®ÄÚÄ«µå",
  27261: "ÁêÄ«µå",
  27262: "µð¿ÍÀÌÄ«µå",
  27263: "ÆäÀÌÄ«³ªºñ¾ÈÄ«µå",
  27264: "Evil_Shadow_Card",
  27265: "Evil_Fanatics_Card",
  27270: "sorry",
  27271: "sorry",
  27272: "sorry",
  27273: "sorry",
  27274: "sorry",
  27286: "¾Ë·Ï´Þ·Ï°õÀÎÇüÄ«µå",
  27287: "ºû³ª´Â°õÀÎÇüÄ«µå",
  27288: "³ëµ¿ÇüÇÍ¸ÇÄ«µå",
  27289: "¿µÈ¥ÀÇÆÄÆíÄ«µå",
  27290: "»ç³äÀÌ±êµç¿É½Ãµð¾ðÄ«µå",
  27291: "°í´ëÀÇÆ®¶óÀÌÁ¶ÀÎÆ®Ä«µå",
  27292: "°í´ëÀÇ½ºÅÍ·¢Æ½°í·½Ä«µå",
  27293: "°í´ëÀÇ¸Þ°¥¸®½ºÄ«µå",
  27294: "°í´ëÀÇÅ¸¿À±ºÄ«Ä«µå",
  27295: "°í´ëÀÇ½ºÅæ½´ÅÍÄ«µå",
  27296: "°í´ëÀÇ¿ìÅº½´ÅÍÄ«µå",
  27297: "°í´ëÀÇ¿ìÅºÆÄÀÌÅÍÄ«µå",
  27298: "°í´ëÀÇ¿ìÅºµðÆæ´õÄ«µå",
  27301: "¹Ì±ÃÀÇµµÇÃ°»¾îÄ«µå",
  27304: "E_Ea2s_Card",
  27305: "El_a17t_Card",
  27306: "Bellare_Card",
  27307: "High_Bellare_Card",
  27308: "Sanare_Card",
  27309: "High_Sanare_Card",
  27310: "Plaga_Card",
  27311: "Mutant_Plaga_Card",
  27312: "Dolor_Card",
  27313: "Mt_Dolor_Card",
  27314: "Venenum_Card",
  27315: "Mt_Venenum_Card",
  27316: "Twin_Caput_Card",
  27317: "Mt_Caput_Card",
  27318: "Miguel_Card",
  27319: "R48_85_Bestia_Card",
  27320: "E_Ea1l_Card",
  27325: "Muspellskoll_Card",
  27326: "MinionOfMorocc_Card",
  27327: "ReaperAnkou_Card",
  27321: "DespairGodMorocc_Card",
  27328: "LivingDeath_Card",
  27322: "Ahat_Card",
  27323: "Shnaim_Card",
  27324: "Brinaranea_Card",
  27329: "Schmidt_Card",
  27338: "È¥µ·ÀÇ¸ÇÆ¼½ºÄ«µå",
  27339: "È¥µ·ÀÇ°í½ºÆ®¸µÄ«µå",
  27340: "È¥µ·ÀÇÅ³·¯¸ÇÆ¼½ºÄ«µå",
  27334: "È¥µ·ÀÇ¹ÙÆ÷¸ÞÆ®Ä«µå",
  27341: "È¥µ·ÀÇÆ÷Æ÷¸µÄ«µå",
  27335: "È¥µ·ÀÇ¹ÙÆ÷¸ÞÆ®ÁÖ´Ï¾îÄ«µå",
  27342: "È¥µ·ÀÇ½ºÅÛ¿úÄ«µå",
  27336: "È¥µ·ÀÇ»çÀÌµå¿ÍÀÎ´õÄ«µå",
  27343: "È¥µ·ÀÇº¹»çÄ«µå",
  27337: "È¥µ·ÀÇÇåÅÍÇÃ¶óÀÌÄ«µå",
  27344: "Witch_Zilant_Card",
  27345: "Dragon_Zilant_Card",
  27346: "Firm_Muspell_Card",
  27347: "Firm_Kaho_Card",
  27348: "Firm_Lava_G_Card",
  27349: "Firm_Explosion_Card",
  27350: "Firm_Deleter1_Card",
  27351: "Firm_Deleter2_Card",
  27352: "Firm_Nightmare_T_Card",
  27353: "Firm_Blazzer_Card",
  27354: "Polluted_Raydric_Card",
  27355: "Polluted_Ray_A_Card",
  27356: "Frozen_Gargoyle_Card",
  27357: "Polluted_Sting_Card",
  27358: "Prison_Breaker_Card",
  27359: "Ice_Ghost_Card",
  27360: "Flame_Ghost_Card",
  27361: "Polluted_W_Man_Card",
  27362: "Polluted_Spi_Q_Card",
  27363: "Polluted_Dark_L_Card",
  27381: "C_Himel_Card",
  27382: "C_CorruptionRoot_Card",
  27383: "C_Amdarais_Card",
  27384: "C_White_Knight_Card",
  27385: "C_Khaliz_Knight_Card",
  27386: "C_Raydric_Card",
  27387: "C_Raydric_Archer_Card",
  27388: "C_Cursed_Butler",
  300001: "Poisonous_Card",
  300002: "Toxious_Card",
  300003: "Porcellio_W_Card",
  300004: "Neo_Mineral_Card",
  300005: "Abyss_Man_Card",
  300006: "Jeweliant_Card",
  300007: "Jungoliant_Card",
  300008: "Angelgolt_Card",
  300009: "Plasma_Spt_Card",
  300010: "Plasma_Arch_Card",
  300011: "Holy_Frus_Card",
  300012: "Holy_Skogul_Card",
  300013: "Reginleif_Card",
  300014: "Ingrid_Card",
  300015: "Ferus_P_Card",
  300016: "Treasure_Mimic_Card",
  300017: "Acidus_B_Card",
  300018: "Acidus_S_Card",
  300019: "Bone_Ferus_Card",
  300020: "Bone_Acidus_Card",
  300021: "Bone_Detale_Card",
  300076: "Beta_Guards_Ng_Card",
  300077: "O_Cleaner_Ng_Card",
  300078: "Sweety_Card",
  300079: "Redpepper_Card",
  300080: "Redpepper_H_Card",
  300081: "Assistant_Card",
  300082: "Assistant_H_Card",
  300083: "Dry_Rafflesia_Card",
  300084: "Dry_Rafflesia_H_Card",
  300085: "Alnoldi_Ex_Card",
  300086: "Alnoldi_Ex_H_Card",
  300087: "Beta_Scissore_Ng_Card",
  300088: "B_Scissore_Ng_H_Card",
  300089: "Verporta_Card",
  300090: "Verporte_H_Card",
  300091: "Papila_Card",
  300092: "Papila_H_Card",
  300093: "Papila_Ruba_Card",
  300094: "Papila_Ruba_H_Card",
  300095: "Papila_Cae_Card",
  300096: "Papila_Cae_H_Card",
  300097: "Aries_Card",
  300098: "Aries_H_Card",
  300099: "Silva_Papilia_Card",
  300100: "Gran_Papilia_Card",
  300101: "Beta_Cleaner_Card",
  300102: "Beta_Baths_A_Card",
  300103: "Bath_Mermaid_Card",
  300104: "Bookworm_Card",
  300105: "Roaming_Splbook_Card",
  300106: "Pitaya_R_Card",
  300107: "Pitaya_Boss_Card",
  300108: "Venenum3_Card",
  300109: "EP17_2_Cramp_Card",
  300110: "Waterfall_Card",
  300111: "Bellare3_Card",
  300112: "Dolor3_Card",
  300113: "Plasma_Y_Card",
  300114: "Plaga3_Card",
  300115: "Sanare3_Card",
  300116: "Plasma_R_Card",
  300117: "Plasma_R2_Card",
  300118: "EP17_2_Phen_Card",
  300119: "EP17_2_Sword_Fish_Card",
  300120: "EP17_2_Piranha_Card",
  300121: "EP17_2_Marc_Card",
  300122: "Pitaya_Y_Card",
  300123: "Pitaya_V_Card",
  300124: "Pitaya_B_Card",
  300125: "Pitaya_G_Card",
  300140: "ILL_Sropho_Card",
  300141: "ILL_Obeaune_Card",
  300142: "ILL_Deviace_Card",
  300143: "ILL_Marse_Card",
  300144: "ILL_Merman_Card",
  300145: "ILL_Abysmal_Witch_Card",
  300146: "ILL_Sedora_Card",
  300147: "ILL_Sword_Fish_Card",
  300148: "ILL_Strouf_Card",
  300149: "ILL_Phen_Card",
  300150: "ILL_King_Dramoh_Card",
  300151: "ILL_Kraken_Card",
  300170: "MD_Airboat_Card",
  300171: "MD_Airboat_Card2",
  300172: "MD_Airboat_Card3",
  300173: "MD_Airboat_Card4",
  300174: "MD_Airboat_Card5",
  300175: "MD_Airboat_Card6",
  300176: "MD_Airboat_Card7",
  27393: "Kathryn_Card",
  27394: "S_Kathryn_Card",
  27395: "Isaac_Card",
  27396: "S_Issac_Card",
  300131: "sorry",
  300132: "sorry",
  300133: "sorry",
  300134: "sorry",
  300135: "sorry",
  300136: "sorry",
  300137: "sorry",
  300138: "sorry",
  300177: "MD_Geffen_Archi_Card",
  300178: "MD_Geffen_Dio_Card",
  300179: "MD_Geffen_Thief_Card",
  300180: "MD_Geffen_Gang_Card",
  300181: "MD_Geffen_Thug_Card",
  300182: "MD_Geffen_Monk_Card",
  300183: "MD_Geffen_Ordre_Card",
  300184: "MD_Geffen_Blut_Card",
  300185: "MD_Geffen_Akuma_Card",
  300186: "MD_Geffen_Hyper_Card",
  300187: "MD_Geffen_Odorico_Card",
  300188: "MD_Geffen_Reche_Card",
  300189: "MD_Geffen_Jew_Card",
  300190: "MD_Geffen_Fei_Card",
  300191: "MD_Geffen_Dy_Card",
  300192: "Sakray_Card",
  300193: "Tiara_Card",
  300211: "EP18_Ash_Toad_Card",
  300212: "EP18_Rakehand_Card",
  300213: "EP18_Spark_Card",
  300214: "EP18_Hot_Molar_Card",
  300215: "EP18_Volcaring_Card",
  300216: "EP18_Lava_Toad_Card",
  300217: "EP18_Burning_Fang_Card",
  300218: "EP18_Ashhopper_Card",
  300219: "EP18_Ashring_Card",
  300220: "EP18_Grey_Wolf_Card",
  300221: "EP18_Tumble_Ring_Card",
  300222: "EP18_Firewind_Kite_Card",
  300223: "EP18_Phantom_Wolf_Card",
  300227: "EP18_Schulang_Card",
  300228: "EP18_Demi_Freyja_Card",
  300240: "Gan_Ceann_Card",
  300241: "Brutal_Murderer_Card",
  300242: "Ghost_Cube_Card",
  300243: "Lude_Gal_Card",
  300244: "Disguiser_Card",
  300245: "Bluemoon_Loli_Ruri_Card",
  300246: "Grote_Card",
  300247: "Pierrotzoist_Card",
  300248: "Death_Witch_Card",
  300249: "Giant_Caput_Card",
  300250: "Dolorian_Card",
  300251: "Plagarion_Card",
  300252: "Deadre_Card",
  300253: "Venedi_Card",
  300254: "Amitera_Card",
  300255: "Litus_Card",
  300256: "Fillia_Card",
  300257: "Vanilaqus_Card",
  300258: "Lava_Eater_Card",
  300259: "Fulgor_Card",
  300260: "Napeo_Card",
  300261: "Galensis_Card",
  300262: "The_One_Card",
  300281: "R001_Bestia_Card",
  300263: "Reken_Guard_Card",
  300264: "Reken_H_Guard_Card",
  300265: "Regen_Scientist_Card",
  300266: "Unknown_Swordman_Card",
  300267: "Crow_Baron_Card",
  300268: "Crow_Duke_Card",
  300269: "Eldest_Card",
  300270: "Empathizer_Card",
  300271: "Happy_Giver_Card",
  300272: "Pray_Giver_Card",
  300273: "Smile_Giver_Card",
  300274: "Tha_Anger_Card",
  300275: "Tha_Horror_Card",
  300276: "Tha_Regret_Card",
  300277: "Tha_Resent_Card",
  300278: "Void_Mimic_Card",
  300279: "Book_Of_Death_Card",
  300280: "Broken_Thanatos_Card",
  300230: "ILL_Andre_Card",
  300231: "ILL_Andre_soldier_Card",
  300232: "ILL_Andre_larva_Card",
  300233: "ILL_Deniro_Card",
  300234: "ILL_Piere_Card",
  300235: "ILL_Ant_egg_Card",
  300236: "ILL_Giearth_Card",
  300237: "ILL_Farmiliar_Card",
  300238: "ILL_Vitata_Card",
  300239: "ILL_Maya_Card",
  300292: "Extra_Joker_Card",
  300293: "Erzsebet_Card",
  300294: "Jeniffer_Card",
  300295: "General_Orc_Card",
  300296: "Sieglouse_Card",
  300297: "Goblin_King_Card",
  300307: "Meyer_Card",
  300308: "S_Meyer_Card",
  300309: "Helmut_Card",
  300310: "S_Helmut_Card",
  300359: "Ice_Gangu_Card",
  300360: "Shining_Seaweed_Card",
  300361: "Ice_Straw_Card",
  300362: "Unfrost_Flower_card",
  300363: "Limacina_Card",
  300364: "Calmaring_Card",
  300365: "Primitive_Rgan_Card",
  300366: "Lowest_Rgan_Card",
  300367: "Junior_Rgan_Card",
  300368: "Middle_G_Rgan_Card",
  300369: "Discarded_P_R_Card",
  300370: "Discarded_L_R_Card",
  300371: "Cave_Calmaring_Card",
  300372: "Cave_Un_Flower_Card",
  300373: "B_Hallucigenia_Card",
  300374: "Hallucigenia_Card",
  300375: "One_E_Dollocaris_Card",
  300376: "Eyes_Dollocaris_Card",
  300377: "Ultra_Limacina_Card",
  300378: "Simulation_Juncea_Card",
  300379: "R_Superior_Rgan_Card",
  300380: "E_Inter_Rgan_Card",
  300381: "Heart_Hunter_AT_Card",
  300382: "Aquila_Card",
  101522: "F_VR_Book001",
  101523: "F_VR_Book002",
  101524: "F_VR_Book003",
  101525: "F_VR_Book004",
  101835: "F_VR_Book005",
  101837: "F_VR_Book008",
  101834: "F_VR_Book009",
  101705: "F_VR_Book006",
  101706: "F_VR_Book007",
  300421: "Catherine_Card",
  300422: "S_Catherine_Card",
  300423: "Friedrich_Card",
  300424: "S_Friedrich_Card",
  300425: "Crux_Card",
  300426: "S_Crux_Card",
  300441: "Burning_Knight_Card",
  300442: "Dedsera_Card",
  300443: "Hardrock_Titan_Card",
  300444: "Deadween_Card",
  300445: "Gaia_Pol_Card",
  300446: "Punch_Bug_Card",
  300447: "Aferde_Card",
  300448: "Dispol_Card",
  300449: "Timbers_Card",
  300450: "Renire_Card",
  300195: "sld_boitata_card",
  300201: "SLD_P_Spi_Q_Card_J",
  300203: "SLD_F_Muspell_Card_J",
  300209: "SLD_G_Amon_Ra_Card_J",
  300455: "Copo_Card",
  300456: "Icewind_Egg_Card",
  300457: "Grey_Icewind_Card",
  300458: "Icewind_Card",
  300459: "E_Rgan_Healer_Card",
  300460: "Jormun_Guardian_Card",
  300461: "Fake_Iwin_S_Card",
  300462: "S_Rgan_Warlock_Card",
  300463: "S_Rgan_Healer_Card",
  300464: "E_Rgan_Warlock_Card",
  300465: "E_Rgan_Guardian_Card",
  300466: "E_Rgan_Cleaner_Card",
  300467: "Angel_Iceslug_Card",
  300468: "Rabbit_Iceslug_card",
  300469: "Melibe_Iceslug_Card",
  300470: "Icebear_Card",
  300471: "F_Angel_Iceslug_Card",
  300472: "Demigod_Lasgand_Card",
  300473: "Snow_Angel_Card",
  300474: "Rgan_Chief_Clean_Card",
  300482: "sorry",
  1001595: "R_Sealed_Rune",
  1001592: "R_Core_Rune",
  300486: "Elena_Card",
  300487: "S_Elena_Card",
  300488: "Lookie_Card",
  300489: "S_Lookie_Card",
  300490: "Est_Card",
  300491: "S_Est_Card",
  300492: "Gony_Card",
  300493: "S_Gony_Card",
  300494: "Tes_Card",
  300495: "S_Tes_Card",
  300496: "Leizi_Card",
  300497: "S_Leizi_Card",
  300505: "Sea_Wind_Card",
  300506: "Scalleg_Card",
  300507: "Velelling_Card",
  300508: "Skipskipper_Card",
  300509: "Letterster_Card",
  300510: "Cliolima_Card",
  300511: "Rock_Striker_Card",
  300512: "Ice_Seahorse_Card",
  300513: "Ice_Horn_Card",
  300514: "Yoster_Cleaner_Card",
  300515: "Yoster_Fixer_Card",
  300516: "Yoster_Collect_Card",
  300517: "Yoster_Nego_Card",
  300518: "Yoster_Cooker_Card",
  300519: "Yormi_Card",
  300520: "Yormi_M_Card",
  300521: "Yordos_Inve_Card",
  300522: "Yordos_Judge_Card",
  300523: "Yordos_Execute_Card",
  300524: "Yoscopus_G_Card",
  300525: "Yoscopus_S_Card",
  300526: "Yorker_Worker_Card",
  300527: "Yorker_R_Worker_Card",
  300528: "Yortus_Bishop_Card",
  300529: "Yortus_Conjur_Card",
  300530: "Yortus_Arbiter_Card",
  300531: "Yortus_Bailiff_Card",
  300532: "Cap_Of_G_Ship_Card",
  300533: "Encroached_Tan_Card",
  300549: "Ocean_Pope_Card",
  300547: "CLB_SS_DF_Card",
  300550: "CLB_SS_EA_Card",
  300551: "CLB_SS_LL_Card",
  300552: "CLB_SS_LT_Card",
  300585: "Tris_Card",
  300586: "Tan_Card",
  300587: "Wilhelm_Card",
  300588: "Reinhardt_Card",
  300589: "Ivan_Card",
  300590: "Lalaila_Card",
  300591: "Richard_Card",
  300592: "Valdaris_Card",
  300593: "Aurelie_Card",
  300594: "Ilse_Heine_Card",
  300595: "Epesto_Card",
  300596: "Maristella_Card",
  300597: "Yohan_Card",
  300598: "Gunter_Card",
  300599: "Galaxia_Card",
  300600: "Iana_Card",
  300601: "Lee_Card",
  300602: "Nadoyo_Card",
  300603: "Dien_Card",
  300604: "Ridsh_Card",
  300605: "Cotness_Card",
  300606: "S_Dien_Card",
  300607: "S_Ridsh_Card",
  300608: "S_Cotness_Card",
  300609: "Sirena_Card",
  300610: "Gurrero_Card",
  300611: "Tatsi_Card",
  300612: "Hanom_Card",
  300613: "Peska_Card",
  300614: "Diosa_Card",
  300618: "CLB_CP_PD_Card",
  300555: "Violen_Card",
  300556: "Spiding_Card",
  300557: "Garling_Card",
  300558: "Jackonette_Card",
  300559: "Liamette_Card",
  300560: "NM_Piamette_Card",
  300561: "Medjed_Card",
  300562: "Medjay_Card",
  300563: "Ophois_Card",
  300564: "Heka_Card",
  300565: "Guide_Of_Dead_Card",
  300633: "sorry",
  300634: "sorry",
  300635: "sorry",
  300636: "sorry",
  300637: "sorry",
  300638: "sorry",
  300639: "sorry",
  300640: "sorry",
  300641: "sorry",
  300642: "sorry",
  300643: "sorry",
  300644: "sorry",
  300645: "sorry",
  300646: "sorry",
  300647: "sorry",
  300648: "sorry",
  300649: "sorry",
  300650: "sorry",
  300651: "sorry",
  300652: "sorry",
  300653: "sorry",
  300654: "sorry",
  300655: "sorry",
  300656: "sorry",
  300657: "sorry",
  300658: "sorry",
  300659: "sorry",
  300660: "sorry",
  300661: "sorry",
  300662: "sorry",
  300663: "sorry",
  300664: "sorry",
  300665: "sorry",
  300666: "sorry",
  300667: "sorry",
  104236: "CLB_HM_Card_WE",
  104237: "CLB_HM_Card_GR",
  104238: "CLB_HM_Card_PK",
  104239: "CLB_HM_Card_PP"
};
